<template>
  <v-dialog
    data-testid="create-carrier-contact-dialog"
    max-width="50%"
    width="50%"
    v-model="isDialogOpen"
    @keydown.escape="closeDialog"
    v-bind="$attrs"
    scrollable>
    <create-carrier-form
      @close="closeDialog"
      @save="handleContactCreated"
      :entry-point="mixpanelEntryPoint"></create-carrier-form>
  </v-dialog>
</template>

<script>
import { defineComponent, computed, onMounted, onUnmounted } from 'vue';
import { useDialogListener } from '@/composables';
import CreateCarrierForm from './CreateCarrierForm.vue';

export default defineComponent({
  name: 'EventTriggeredCreateCarrierContactDialog',
  components: {
    CreateCarrierForm
  },
  setup() {
    const {
      isDialogOpen,
      dialogProps,
      closeDialog,
      subscribeToDialogEvent,
      unsubscribeFromDialogEvent
    } = useDialogListener('open-create-carrier-contact-dialog');

    onMounted(() => {
      subscribeToDialogEvent();
    });

    onUnmounted(() => {
      unsubscribeFromDialogEvent();
    });

    const mixpanelEntryPoint = computed(() => dialogProps.value?.mixpanelEntryPoint);
    const onContactCreated = computed(() => dialogProps.value?.onContactCreated);

    const handleContactCreated = contact => {
      onContactCreated.value?.(contact);
    };

    return {
      mixpanelEntryPoint,
      isDialogOpen,
      closeDialog,
      handleContactCreated
    };
  }
});
</script>

<style scoped lang="scss">
.org-favorite-checkbox.text--disabled > :deep(.v-input__control > .v-input__slot > .v-label) {
  color: $color-text-disabled !important;
}

.org-favorite-checkbox {
  :deep(.v-label) {
    font-weight: 400 !important;
  }
}
</style>
